document.addEventListener('DOMContentLoaded', ()=>{
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => Array.from(c.querySelectorAll(s));
  const normalize = (s) => (s || '').toLowerCase().trim();

  /* ===================== Helpers ===================== */
  function parseWeightFromTitle(title){
    const m = (title || '').toLowerCase().match(/(\d+(?:\.\d+)?)\s*lb\b/);
    return m ? parseFloat(m[1]) : null;
  }
  function getColorIndex(optionNames){
    if(!Array.isArray(optionNames)) return -1;
    let idx=-1; optionNames.forEach((n,i)=>{ if(normalize(n).includes('color')) idx=i; });
    return idx;
  }
  function matchVariantStrict(variants, colorIdx, colorVal, weightVal){
    const wantW = parseFloat(weightVal);
    return variants.find(v=>{
      const vW = parseWeightFromTitle(v.title);
      if(vW===null || vW !== wantW) return false;
      if(colorIdx<0) return true;
      const optVal = colorIdx===0? v.o1 : colorIdx===1? v.o2 : v.o3;
      return normalize(optVal) === normalize(colorVal);
    }) || null;
  }
  function setNote(card,text,cls, onBack=false){
    const sel = onBack ? '.cb-back-note' : '.cb-card-note';
    const note=card.querySelector(sel); if(!note) return;
    note.className=(onBack? 'cb-card-note cb-back-note' : 'cb-card-note')+(cls?` ${cls}`:'');
    note.textContent=text||'';
  }
  function setCardImage(card, url){
    card.querySelectorAll('.cb-product-img').forEach(img=>{ if(url) img.src = url; });
  }
  function updateFrontSummary(card){
    const w = card.dataset.localWeight || '0.5';
    const q = card.dataset.localQty || '1';
    const color = card.dataset.localColor || '';
    const cEl = card.querySelector('.cb-sum-color');
    const wEl = card.querySelector('.cb-sum-weight');
    const qEl = card.querySelector('.cb-sum-qty');
    if(cEl){
      if(color){ cEl.style.display=''; cEl.textContent=color; }
      else { cEl.style.display='none'; cEl.textContent=''; }
    }
    if(wEl) wEl.textContent = `${w} LB`;
    if(qEl) qEl.textContent = `Qty ${q}`;
  }
  function updateWeightButtons(card,w){
    $$('.cb-wi-btn',card).forEach(b=>{
      const active=+b.dataset.w===+w;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function updateColorButtons(card,colorVal){
    $$('.cb-color-btn',card).forEach(b=>{
      const active = (b.dataset.color||'').toLowerCase() === (colorVal||'').toLowerCase();
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }
  function currentPriceCents(card){
    let variants=[]; try{ variants=JSON.parse(card.dataset.variants||'[]'); }catch{}
    const optionNames = JSON.parse(card.dataset.optionNames||'[]');
    const colorIdx = getColorIndex(optionNames);
    const colorVal = card.dataset.localColor || '';
    const w = +card.dataset.localWeight || 0.5;

    const m = matchVariantStrict(variants, colorIdx, colorVal, w);
    if(m && typeof m.price_cents === 'number') return m.price_cents;

    let min = Infinity;
    variants.forEach(v=>{
      if(typeof v.price_cents === 'number') min = Math.min(min, v.price_cents);
    });
    return Number.isFinite(min)? min : Infinity;
  }

  /* ===================== State ===================== */
  const state={
    search:'',
    sort:'reco',
    filterColor:'',      // value or ''
    filterType:'',       // product.type value or ''
    onlyHasColor:false,
    onlyOnSale:false,
    onlyIndWrapped:false,
    defaultWeight:'0.5'
  };

  /* ===================== Preserve original order for "Recommended" ===================== */
  const grid = document.querySelector('.cb-grid');
  if(grid){
    Array.from(grid.children).forEach((el, idx)=>{
      if(el.classList.contains('cb-card')){
        el.dataset.index = String(idx);   // original order index for "Recommended"
      }
    });
  }

  /* ===================== Card Init ===================== */
  document.querySelectorAll('.cb-card').forEach(card=>{
    card.dataset.localWeight = state.defaultWeight;
    card.dataset.localQty = '1';

    const variants = JSON.parse(card.dataset.variants || '[]');
    const optionNames = JSON.parse(card.dataset.optionNames || '[]');
    const colorIdx = getColorIndex(optionNames);
    const colorSection = card.querySelector('.cb-color-section');
    const colorGrid = card.querySelector('.cb-color-grid');

    if(colorIdx >= 0){
      const seen = new Set(); const colors=[];
      variants.forEach(v=>{
        const val = colorIdx===0? v.o1 : colorIdx===1? v.o2 : v.o3;
        if(val && !seen.has(val)){ seen.add(val); colors.push(val); }
      });
      if(colors.length){
        colorSection.style.display = '';
        colorGrid.innerHTML = colors.map((c)=>(
          `<button type="button" class="cb-color-btn" data-color="${c.replace(/"/g,'&quot;')}">${c}</button>`
        )).join('');
        const initColor = card.dataset.initialColor || colors[0];
        card.dataset.localColor = initColor;
      }else{
        colorSection.style.display = 'none';
        card.dataset.localColor = '';
      }
    }else{
      colorSection.style.display = 'none';
      card.dataset.localColor = '';
    }

    const inner = card.querySelector('.cb-card-inner');
    const customizeBtn = card.querySelector('.cb-customize-btn');
    theDoneBtn = card.querySelector('.cb-done-btn');
    const qtyInput = card.querySelector('.cb-qty-input');
    const dec=card.querySelector('.cb-qty-dec');
    const inc=card.querySelector('.cb-qty-inc');
    const addFront = card.querySelector('.cb-add-btn-front');

    customizeBtn?.addEventListener('click',(e)=>{
      e.preventDefault();
      inner.classList.add('is-flipped');
      card.querySelector('.cb-back').setAttribute('aria-hidden','false');
      requestAnimationFrame(sizeAllTiles);
    });
    theDoneBtn?.addEventListener('click',(e)=>{
      e.preventDefault();
      inner.classList.remove('is-flipped');
      card.querySelector('.cb-back').setAttribute('aria-hidden','true');
      updateFrontSummary(card);
      requestAnimationFrame(sizeAllTiles);
    });

    card.addEventListener('click',(e)=>{
      const colorBtn = e.target.closest('.cb-color-btn');
      const wBtn = e.target.closest('.cb-wi-btn');
      if(colorBtn){
        e.preventDefault();
        card.dataset.localColor = colorBtn.dataset.color || '';
        refreshCard(card); requestAnimationFrame(sizeAllTiles);
      }
      if(wBtn){
        e.preventDefault();
        card.dataset.localWeight = wBtn.dataset.w;
        refreshCard(card); requestAnimationFrame(sizeAllTiles);
      }
    });

    const decInc = (delta)=>{
      const now = Math.max(1, (+card.dataset.localQty||1)+delta);
      card.dataset.localQty = String(now);
      if(qtyInput) qtyInput.value = String(now);
      updateFrontSummary(card);
      requestAnimationFrame(sizeAllTiles);
    };
    dec?.addEventListener('click',(e)=>{ e.preventDefault(); decInc(-1); });
    inc?.addEventListener('click',(e)=>{ e.preventDefault(); decInc(+1); });
    qtyInput?.addEventListener('input',()=>{
      const now = Math.max(1, parseInt(qtyInput.value||'1',10) || 1);
      card.dataset.localQty = String(now);
      qtyInput.value = String(now);
      updateFrontSummary(card);
      requestAnimationFrame(sizeAllTiles);
    });

    addFront?.addEventListener('click', async (e)=>{
      e.preventDefault();
      const id = card.dataset.matchedVariantId;
      const qty = Math.max(1, parseInt(card.dataset.localQty||'1',10) || 1);
      const w = card.dataset.localWeight || state.defaultWeight;
      if(!id){ setNote(card,'Pick a valid option first.','cb-note-warn'); return; }
      const prevLabel = addFront.textContent;
      try{
        addFront.disabled = true;
        addFront.textContent = 'Adding…';
        setNote(card,'','');
        const r = await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({ items: [{ id: +id, quantity: qty, properties: { '_Builder_weight': `${w} lb` } }] })
        });
        if(!r.ok) throw new Error(await r.text());
      }catch(err){
        console.error(err);
        setNote(card,'Error adding to cart.','cb-note-err');
      }finally{
        addFront.disabled = false;
        addFront.textContent = prevLabel || 'Add To Cart';
      }
    });

    refreshCard(card);
  });

  /* ===================== Build Menus: Color & Type ===================== */
  (function buildFacetMenus(){
    const colorSet = new Set();
    const typeSet = new Set();

    document.querySelectorAll('.cb-card').forEach(card=>{
      const productType = (card.dataset.productType||'').trim();
      if(productType) typeSet.add(productType);

      let variants=[]; try{ variants=JSON.parse(card.dataset.variants||'[]'); }catch{}
      const optionNames = JSON.parse(card.dataset.optionNames||'[]');
      const colorIdx = getColorIndex(optionNames);
      if(colorIdx>=0){
        variants.forEach(v=>{
          const val = colorIdx===0? v.o1 : colorIdx===1? v.o2 : v.o3;
          if(val) colorSet.add(val);
        });
      }
    });

    const colorList = $('#cb-color-list');
    const typeList = $('#cb-type-list');

    const addMenuItem = (list, label, value, datasetKey) => {
      const btn = document.createElement('button');
      btn.type='button';
      btn.className='cb-menu-item';
      btn.textContent = label;
      btn.dataset[datasetKey] = value;
      list.appendChild(btn);
    };

    // Color menu (no "Any" option)
    Array.from(colorSet).sort((a,b)=>a.localeCompare(b)).forEach(c=>{
      addMenuItem(colorList,c,c,'color');
    });

    // Type menu (no "Any" option)
    Array.from(typeSet).sort((a,b)=>a.localeCompare(b)).forEach(t=>{
      addMenuItem(typeList,t,t,'type');
    });
  })();

  /* ===================== Initial active states for menus ===================== */
  (function initMenuActiveStates(){
    // Sort: Recommended
    const sortList = document.querySelector('.cb-menu[data-menu="sort"] .cb-menu-list');
    if(sortList){
      const defSort = sortList.querySelector('.cb-menu-item[data-sort="'+ state.sort +'"]');
      if(defSort) defSort.classList.add('is-active');
    }
    // Default weight
    const weightList = document.querySelector('.cb-menu[data-menu="weight"] .cb-menu-list');
    if(weightList){
      const defWeight = weightList.querySelector('.cb-menu-item[data-w="'+ state.defaultWeight +'"]');
      if(defWeight) defWeight.classList.add('is-active');
    }
  })();

  /* ===================== Filtering / Search ===================== */
  const sIn=$('#cb-search-input'), sClr=$('#cb-search-clear');
  sIn?.addEventListener('input',e=>{ state.search=e.target.value; runFilterSort(); });
  sClr?.addEventListener('click',()=>{ sIn.value=''; state.search=''; runFilterSort(); sIn.focus(); });

  $('#cb-filter-hascolor')?.addEventListener('change',e=>{
    state.onlyHasColor = e.target.checked;
    updateFilterSummary();
    runFilterSort();
  });
  $('#cb-filter-indwrapped')?.addEventListener('change',e=>{
    state.onlyIndWrapped = e.target.checked;
    updateFilterSummary();
    runFilterSort();
  });

  function updateFilterSummary(){
    // intentionally left blank – you don't want text summaries on the buttons
  }

  function cardPassesFilters(card){
    // text
    const q=(state.search||'').toLowerCase();
    if(q){
      const t=(card.dataset.title||'').toLowerCase();
      if(!t.includes(q)) return false;
    }
    // color (if selected)
    if(state.filterColor){
      const colorInTitle = (card.dataset.title||'').toLowerCase().includes(state.filterColor.toLowerCase());
      if(!colorInTitle){
        let has=false;
        let variants=[]; try{ variants=JSON.parse(card.dataset.variants||'[]'); }catch{}
        const optionNames = JSON.parse(card.dataset.optionNames||'[]');
        const colorIdx = getColorIndex(optionNames);
        if(colorIdx>=0){
          has = variants.some(v=>{
            const val = colorIdx===0? v.o1 : colorIdx===1? v.o2 : v.o3;
            return normalize(val)===normalize(state.filterColor);
          });
        }
        if(!has) return false;
      }
    }
    // type
    if(state.filterType){
      const pt = (card.dataset.productType||'').trim();
      if(pt !== state.filterType) return false;
    }
    // has color
    if(state.onlyHasColor){
      const optionNames = JSON.parse(card.dataset.optionNames||'[]');
      if(getColorIndex(optionNames)<0) return false;
    }
    // on sale (expects data-onsale="true" on cb-card if you set it)
    if(state.onlyOnSale){
      if((card.dataset.onsale || '') !== 'true') return false;
    }
    // individually wrapped (expects data-indwrapped="true" on cb-card if you set it)
    if(state.onlyIndWrapped){
      if((card.dataset.indwrapped || '') !== 'true') return false;
    }

    return true;
  }

  function sortCards(cards){
    const sort = state.sort;
    if(sort==='reco'){
      // restore original collection order using data-index
      return cards.slice().sort((a,b)=>
        (+(a.dataset.index||0)) - (+(b.dataset.index||0))
      );
    }
    const withPrice = cards.map(card=>({ card, price: currentPriceCents(card)}));
    if(sort==='price-asc'){
      withPrice.sort((a,b)=> a.price - b.price);
    }else if(sort==='price-desc'){
      withPrice.sort((a,b)=> b.price - a.price);
    }
    return withPrice.map(x=>x.card);
  }

  function runFilterSort(){
    const grid = document.querySelector('.cb-grid');
    const cards = Array.from(grid.children).filter(el=>el.classList.contains('cb-card'));

    // filter
    cards.forEach(c=>{
      c.style.display = cardPassesFilters(c) ? '' : 'none';
    });

    // sort (only visible)
    const visible = cards.filter(c=> c.style.display!=='none');
    const sorted = sortCards(visible);
    // append in sorted order
    sorted.forEach(c=> grid.appendChild(c));

    requestAnimationFrame(sizeAllTiles);
  }

  /* ===================== Menus wiring ===================== */
  document.addEventListener('click', (e)=>{
    // open/close menus
    const btn = e.target.closest('.cb-menu-button');
    if(btn){
      const menu = btn.closest('.cb-menu');
      const open = menu.getAttribute('aria-expanded')==='true';
      $$('.cb-menu[aria-expanded="true"]').forEach(m=> m.setAttribute('aria-expanded','false'));
      menu.setAttribute('aria-expanded', open ? 'false' : 'true');
      return;
    }

    // pick color (toggle off if same clicked again)
    const colorItem = e.target.closest('.cb-menu-item[data-color]');
    if(colorItem){
      const val = colorItem.dataset.color || '';
      const newVal = (state.filterColor === val ? '' : val);
      state.filterColor = newVal;

      const container = colorItem.closest('.cb-filter-chips') || colorItem.parentElement;
      if(container){
        container.querySelectorAll('.cb-menu-item[data-color]').forEach(btn=>{
          btn.classList.toggle('is-active', newVal && btn.dataset.color === newVal);
        });
      }

      e.target.closest('.cb-menu').setAttribute('aria-expanded','false');
      runFilterSort();
      return;
    }

    // pick type (toggle off if same clicked again)
    const typeItem = e.target.closest('.cb-menu-item[data-type]');
    if(typeItem){
      const val = typeItem.dataset.type || '';
      const newVal = (state.filterType === val ? '' : val);
      state.filterType = newVal;

      const container = typeItem.closest('.cb-filter-chips') || typeItem.parentElement;
      if(container){
        container.querySelectorAll('.cb-menu-item[data-type]').forEach(btn=>{
          btn.classList.toggle('is-active', newVal && btn.dataset.type === newVal);
        });
      }

      e.target.closest('.cb-menu').setAttribute('aria-expanded','false');
      runFilterSort();
      return;
    }

    // pick sale (single "On sale" toggler)
    const saleItem = e.target.closest('.cb-menu-item[data-sale]');
    if(saleItem){
      const val = saleItem.dataset.sale || '';
      if(val === 'on'){
        state.onlyOnSale = !state.onlyOnSale;

        const container = saleItem.closest('.cb-filter-chips') || saleItem.parentElement;
        if(container){
          const btn = container.querySelector('.cb-menu-item[data-sale="on"]');
          if(btn){
            btn.classList.toggle('is-active', state.onlyOnSale);
          }
        }
      }
      e.target.closest('.cb-menu').setAttribute('aria-expanded','false');
      runFilterSort();
      return;
    }

    // pick sort
    const sortItem = e.target.closest('.cb-menu-item[data-sort]');
    if(sortItem){
      state.sort = sortItem.dataset.sort;

      const menuList = sortItem.closest('.cb-menu-list');
      if(menuList){
        menuList.querySelectorAll('.cb-menu-item[data-sort]').forEach(btn=>{
          btn.classList.toggle('is-active', btn === sortItem);
        });
      }

      e.target.closest('.cb-menu').setAttribute('aria-expanded','false');
      runFilterSort();
      return;
    }

    // pick default weight
    const weightItem = e.target.closest('.cb-menu-item[data-w]');
    if(weightItem){
      state.defaultWeight = String(weightItem.dataset.w);

      const menuList = weightItem.closest('.cb-menu-list');
      if(menuList){
        menuList.querySelectorAll('.cb-menu-item[data-w]').forEach(btn=>{
          btn.classList.toggle('is-active', btn === weightItem);
        });
      }

      // apply to all cards
      document.querySelectorAll('.cb-card').forEach(card=>{
        card.dataset.localWeight = state.defaultWeight;
        refreshCard(card);
      });
      e.target.closest('.cb-menu').setAttribute('aria-expanded','false');
      runFilterSort();
      return;
    }

    // click outside closes menus
    if(!e.target.closest('.cb-menu')){
      $$('.cb-menu[aria-expanded="true"]').forEach(m=> m.setAttribute('aria-expanded','false'));
    }
  });

  /* ===================== refreshCard (price, images, buttons) ===================== */
  function refreshCard(card){
    const optionNames = JSON.parse(card.dataset.optionNames || '[]');
    const colorIdx = getColorIndex(optionNames);
    const colorVal = card.dataset.localColor || '';
    const w = +card.dataset.localWeight || 0.5;
    let variants=[]; try{ variants=JSON.parse(card.dataset.variants||'[]'); }catch{}

    const backPriceEl=card.querySelector('.cb-price-back');
    const frontPriceEl=card.querySelector('.cb-price-front');
    const qtyInput = card.querySelector('.cb-qty-input');
    const addFront = card.querySelector('.cb-add-btn-front');

    updateFrontSummary(card);
    updateWeightButtons(card,w);
    if(colorIdx>=0) updateColorButtons(card,colorVal);

    const match=matchVariantStrict(variants, colorIdx, colorVal, w);
    if(match){
      card.dataset.matchedVariantId=match.id;
      const money = match.price_money || '—';
      if(backPriceEl) backPriceEl.textContent = money;
      if(frontPriceEl) frontPriceEl.textContent = money;

      if(match.image){ setCardImage(card, match.image); }
      else if(card.dataset.initialImage){ setCardImage(card, card.dataset.initialImage); }

      const canAdd = !!match.available || (String(match.inventory_policy||'').toLowerCase()==='continue');
      if(qtyInput) qtyInput.disabled = !canAdd;
      if(addFront) addFront.disabled = !canAdd;
      if(!canAdd){ setNote(card,`Unavailable in ${colorVal? colorVal+' • ' : ''}${w} lb.`,'cb-note-err', true); }
      else{ setNote(card,'','', true); }
    }else{
      delete card.dataset.matchedVariantId;
      if(backPriceEl) backPriceEl.textContent = '—';
      if(frontPriceEl) frontPriceEl.textContent = '—';
      if(qtyInput) qtyInput.disabled = true;
      if(addFront) addFront.disabled = true;
      const what = `${colorVal? colorVal+' • ' : ''}${w} lb`;
      setNote(card,`Not offered in ${what}.`,'cb-note-warn', true);
      const initial = card.dataset.initialImage;
      if(initial){ setCardImage(card, initial); }
    }
  }

  /* ===================== Search initially ===================== */
  runFilterSort();

  /* --- Auto-tint (kept) --- */
  document.querySelectorAll('.cb-card img.cb-product-img').forEach(img=>{
    const card = img.closest('.cb-card');
    const colorCanvas = document.createElement('canvas');
    const ctx = colorCanvas.getContext('2d');
    img.addEventListener('load', ()=>{
      try {
        colorCanvas.width = img.naturalWidth;
        colorCanvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        const { data } = ctx.getImageData(0, 0, colorCanvas.width, colorCanvas.height);
        let r=0,g=0,b=0,count=0;
        for(let i=0; i<data.length; i+=40){ r+=data[i]; g+=data[i+1]; b+=data[i+2]; count++; }
        r=Math.round(r/count); g=Math.round(g/count); b=Math.round(b/count);
        const tint = `rgba(${r}, ${g}, ${b}, 0.25)`;
        card.style.backgroundColor = tint;
        card.querySelectorAll('.cb-card-media, .cb-back-media').forEach(m=>{ m.style.backgroundColor = 'transparent'; });
      } catch(e){ /* noop */ }
    });
  });
});

/* --- GLOBAL TILE HEIGHT: set every tile to the tallest (front/back) --- */
(function(){
  const $all = sel => Array.from(document.querySelectorAll(sel));

  function naturalHeights(card){
    const inner = card.querySelector('.cb-card-inner');
    const front = card.querySelector('.cb-front');
    const back  = card.querySelector('.cb-back');
    if(!inner || !front || !back) return 0;

    const isFlipped = inner.classList.contains('is-flipped');
    const prevTransform = inner.style.transform;

    const origFrontPos = front.style.position;
    const origBackPos  = back.style.position;
    const origFrontH   = front.style.height;
    const origBackH    = back.style.height;

    inner.style.transform = 'none';
    front.style.position = 'static';
    back.style.position  = 'static';
    front.style.height = 'auto';
    back.style.height  = 'auto';

    const hFront = front.scrollHeight;
    const hBack  = back.scrollHeight;
    const h      = Math.max(hFront, hBack);

    front.style.position = origFrontPos || 'absolute';
    back.style.position  = origBackPos  || 'absolute';
    front.style.height = origFrontH || '';
    back.style.height  = origBackH  || '';
    inner.style.transform = prevTransform || '';
    if(isFlipped) inner.classList.add('is-flipped'); else inner.classList.remove('is-flipped');

    return h;
  }

  window.sizeAllTiles = function sizeAllTiles(){
    const cards = $all('.cb-card').filter(c => c.style.display !== 'none');
    if(!cards.length) return;

    let tallest = 0;
    for(const card of cards){
      const h = naturalHeights(card);
      if(h > tallest) tallest = h;
    }
    if(tallest < 1) return;

    for(const card of cards){
      card.style.setProperty('--tile-h', tallest + 'px');
      const front = card.querySelector('.cb-front');
      const back  = card.querySelector('.cb-back');
      if(front) front.style.height = '100%';
      if(back)  back.style.height  = '100%';
    }
  };

  window.addEventListener('load', sizeAllTiles);

  const imgs = $all('.cb-card img');
  imgs.forEach(img=>{
    if(!img.complete){ img.addEventListener('load', ()=> window.sizeAllTiles()); }
  });

  document.addEventListener('click', (e)=>{
    if(e.target.closest('.cb-wi-btn') || e.target.closest('.cb-color-btn') ||
       e.target.closest('.cb-qty-btn') || e.target.closest('.cb-customize-btn') ||
       e.target.closest('.cb-done-btn')){
      requestAnimationFrame(window.sizeAllTiles);
    }
  });
  document.addEventListener('input', (e)=>{
    if(e.target.classList && e.target.classList.contains('cb-qty-input')){
      requestAnimationFrame(window.sizeAllTiles);
    }
  });

  let rAF;
  const onResize = ()=>{ cancelAnimationFrame(rAF); rAF = requestAnimationFrame(window.sizeAllTiles); };
  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  const ro = new ResizeObserver(()=> window.sizeAllTiles());
  $all('.cb-card .cb-card-inner').forEach(node => ro.observe(node));
})();